// BannerCustomDialog.js
import ImageIcon from "@mui/icons-material/Image";

import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Grid,
  InputLabel,
  Stack,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import { APP_ICONS } from "../../assets";
import Loader from "../../components/loader";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(5, 4),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(4),
    },
  },
  "& .MuiPaper-root": {
    width: "550px",
    borderRadius: "20px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
}));

// Main Dialog Component
let paramsData = {};
const BannerCustomDialog = forwardRef(
  (
    {
      imageBtnRef,
      imgUrl,
      setImgUrl,
      handleOpenImageInput,
      handleUpload,
      handleCreateBanners,
      isLoading,
    },
    ref
  ) => {
    const [open, setOpen] = useState(false);

    useImperativeHandle(ref, () => ({
      openDialog(params) {
        paramsData = params;
        setOpen(true);
      },
      closeDialog() {
        setOpen(false);
      },
    }));

    const closeDialog = () => {
      setOpen(false);
    };

    return (
      <BootstrapDialog onClose={closeDialog} open={open}>
        <DialogContent>
          <Typography
            fontSize={"1.375rem"}
            fontWeight={600}
            textAlign={"center"}
            color={"primary.light"}
          >
            Upload Your Banner
          </Typography>

          <InputLabel>Upload Banner</InputLabel>

          <Grid container spacing={2}>
            <Grid item xs={12} md={8}>
              <Stack
                flex={1}
                height={200}
                borderRadius={5}
                border={"1px solid #B2B2B2"}
                margin={"10px 0"}
                alignItems={"center"}
                justifyContent={"center"}
              >
                {imgUrl ? (
                  <Box
                    component="img"
                    src={imgUrl}
                    alt="Uploaded Banner"
                    sx={{ width: "100%", height: "100%", borderRadius: 5 }}
                  />
                ) : (
                  <>
                    <ImageIcon
                      style={{
                        color: "#B2B2B2",
                        fontSize: 55,
                      }}
                    />
                    <Typography fontSize={"body1"} color="#B2B2B2">
                      Banner Image
                    </Typography>
                    <Typography
                      fontSize={"0.7rem"}
                      fontWeight={600}
                      textAlign={"center"}
                      color="#B2B2B2"
                    >
                      Image must have an approximate 230 x 340.
                    </Typography>
                  </>
                )}
              </Stack>
            </Grid>
            <Grid item xs={12} md={4}>
              <Button
                variant="contained"
                onClick={handleOpenImageInput} // Ensures file dialog opens on click
                sx={{ mt: 2, height: 45 }}
              >
                Upload
              </Button>
              <Button
                variant="contained"
                sx={{
                  mt: 2,
                  height: 45,
                  bgcolor: "red",
                }}
                onClick={() => setImgUrl(null)}
                disabled={!imgUrl}
              >
                Remove
              </Button>
              <input
                type="file"
                accept="image/*"
                ref={imageBtnRef}
                style={{ display: "none" }}
                onChange={handleUpload}
              />
            </Grid>
          </Grid>

          <Stack direction="row" alignItems="center" gap={1} mt={4}>
            <Button
              disabled={!imgUrl}
              variant="custom_outlined"
              onClick={handleCreateBanners}
              endIcon={
                <img
                  src={APP_ICONS.fileSaveIconBlue}
                  width={22}
                  alt="Save Icon"
                />
              }
            >
              Create
            </Button>
            <Button variant="suspend_button" onClick={closeDialog}>
              Discard
            </Button>
          </Stack>
        </DialogContent>
        <Loader isLoading={isLoading} />
      </BootstrapDialog>
    );
  }
);

export default BannerCustomDialog;
